// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../apps/server/HBuilderX/plugins/uniapp-cli/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "uni-page-body{height:100%}::-webkit-scrollbar{width:3px}::-webkit-scrollbar-track{background-color:rgba(255,0,0,0)}::-webkit-scrollbar-thumb{width:3px;background:#ddd;border-radius:2px}.uni-input-input{color:#000}", ""]);
// Exports
module.exports = exports;
